import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 py-5 text-left"
            >
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                {item.q}
              </h3>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-700">
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
              </span>
            </button>
            {isOpen && (
              <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{item.a}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}